import cx from 'classnames';
import { useFormikContext } from 'formik';
import { LightOutlineButton } from 'components/Buttons';
import { HandThumbsDown, HandThumbsDownFill, HandThumbsUp, HandThumbsUpFill } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

export function CheckChangesHeader({ block }) {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext();
    const { changes = [] } = block;

    if (changes.length === 0) {
        return null;
    }

    const changeIds = changes.map((change) => change.diffId);

    const allChangesProcessed = changes.every((blockChange) => {
        const changeInForm = values.changes.find((formChange) => formChange.diffId === blockChange.diffId);

        return changeInForm?.processed === true;
    });

    const allAccepted = changes.every((blockChange) => {
        const changeInForm = values.changes.find((formChange) => formChange.diffId === blockChange.diffId);

        return changeInForm?.processed === true && changeInForm?.accepted === true;
    });

    const hasChanges = !allChangesProcessed;

    return (
        <div
            className={cx('flex-center justify-content-center check-changes-header p-4', {
                'has-changes': hasChanges,
                'no-changes': !hasChanges,
                accepted: !hasChanges && allAccepted,
                rejected: !hasChanges && !allAccepted,
            })}
        >
            <LightOutlineButton
                size="sm"
                onClick={() => processBlockChanges('accept')}
                tooltip={t('documents:document.editArea.changes.tooltips.acceptChange')}
                className="mr-2"
            >
                {!hasChanges && allAccepted ? (
                    <>
                        <HandThumbsUpFill size={14} className="text-success" />
                        {t('documents:document.editArea.changes.accepted')}
                    </>
                ) : (
                    <>
                        <HandThumbsUp size={14} className="text-success" />
                        {t('documents:document.editArea.changes.accept')}
                    </>
                )}
            </LightOutlineButton>

            <LightOutlineButton
                size="sm"
                onClick={() => processBlockChanges('reject')}
                tooltip={t('documents:document.editArea.changes.tooltips.rejectChange')}
            >
                {!hasChanges && !allAccepted ? (
                    <>
                        <HandThumbsDownFill size={14} className="text-danger" />
                        {t('documents:document.editArea.changes.rejected')}
                    </>
                ) : (
                    <>
                        <HandThumbsDown size={14} className="text-danger" />
                        {t('documents:document.editArea.changes.reject')}
                    </>
                )}
            </LightOutlineButton>
        </div>
    );

    function processBlockChanges(action) {
        const newChanges = [...values.changes]
            .filter((change) => changeIds.includes(change.diffId) === false)
            .concat(
                changes.map((part) => {
                    return {
                        ...part,
                        blockId: block.id,
                        processed: true,
                        accepted: action === 'accept',
                    };
                }),
            );

        setFieldValue('changes', newChanges);
    }
}
